import React from 'react'

import LocationBoxes from '../components/LocationsBoxes/v2/LocationBoxes'

export default function LocationBoxesV2(props) {
  const {
    // businessData,
    // configData,
    // pageTitle,
    // gonationID,
    // locationIndex,
    variantName
    // options,
  } = props

  const variant = variantName ? variantName : 'locationBoxesV2'

  return <LocationBoxes {...props} variantName={variant} />
}
